import { Box, Grid, makeStyles } from "@material-ui/core"
import NCModal from "../../shared/NCModal"
import NCButton from "../../shared/NCButton"
import NCInput from "../../shared/NCInput"
import { DriverProfileIcon, SearchIcon } from "../../libs/icons"
import NCText from "../../shared/NCText"
import { useState } from "react"
import { useAssignAidMonitor } from "../../services/mutations"
import { toast } from "react-toastify"
import { useQueryClient } from "react-query"
import { useGetAidMonitorList } from "../../services/queries"
import API from "../../libs/api"
import { API_PATH } from "../../libs/config"

const useStyles = makeStyles({
  driver: {
    marginBottom: "10px",
    borderRadius: "35px",
    display: "inline-flex",
    position: "relative",
    cursor: "pointer",
    width: "100%",

    "&:hover": {
      backgroundColor: "#1EAAC4"
    }
  },
  driver_active: {
    background: "#1EAAC4"
  }
})
const AddChangeAidMonitorModal = ({
  modalState = false,
  handleClose,
  tripId,
  selectedAidMonitor,
  groupId
}) => {
  const cls = useStyles()
  const [query, setQuery] = useState("")
  const [selectedAidMonitorId, setSelectedAidMonitorId] = useState(selectedAidMonitor)
  const [submitting, setSubmitting] = useState(false)
  const queryClient = useQueryClient()
  const assignAidMonitor = useAssignAidMonitor()
  const { data } = useGetAidMonitorList(1, query, 100, {}, { enabled: modalState })
  const aidMonitorList = data?.data?.data?.results || []

  const handleAidMonitorData = (aidMonitor) => {
    const id = aidMonitor?.user
    setSelectedAidMonitorId(id)
  }

  const handleAssignAidMonitor = () => {
    if (submitting || assignAidMonitor.isLoading) return
    if (!selectedAidMonitorId) {
      toast.error("Please select an Aid/Monitor")
      return
    }
    setSubmitting(true)

    // Reassign during hold: call resolve-no-show directly (single call handles everything)
    if (groupId) {
      API.post(API_PATH.RESOLVE_NO_SHOW(groupId), {
        action: "reassign",
        new_aid_monitor_id: selectedAidMonitorId
      }).then(() => {
        toast.success("AM reassigned successfully.")
        queryClient.invalidateQueries(["getRideDetails"])
        queryClient.invalidateQueries(["getRideGroups"])
        handleClose()
      }).catch(() => toast.error("Failed to resolve hold"))
        .finally(() => setSubmitting(false))
      return
    }

    // Normal assign-aid-monitor flow (not a hold scenario)
    const data = {
      aid_monitor: selectedAidMonitorId,
      id: tripId
    }
    assignAidMonitor.mutate(data, {
      onSuccess: () => {
        toast.success("Aid/Monitor Assigned successfully!")
        queryClient.invalidateQueries(["getRideDetails"])
        handleClose()
      },
      onSettled: () => setSubmitting(false)
    })
  }

  const requestModal = (
    <>
      <Grid container>
        <Grid item xs={12}>
          <NCText
            style={{
              marginLeft: "16px",
              color: "#2E3B36",
              fontSize: "14px",
              fontWeight: "550"
            }}
          >
            Best suitable Aid/Monitors list in recommended order for this Request
          </NCText>
        </Grid>
        <Grid item xs={12} style={{ margin: "10px" }}>
          <NCInput
            style={{ width: "100%" }}
            placeholder={"Search here"}
            value={query}
            onChange={e => {
              setQuery(e.target.value)
            }}
            startIcon={SearchIcon}
            className="rounded"
          />
        </Grid>
        <Box
          style={{
            overflow: "hidden",
            overflowY: "scroll",
            margin: "10px",
            maxHeight: "250px",
            width: "100%"
          }}
        >
          {aidMonitorList && aidMonitorList.length > 0 ? (
            aidMonitorList
              .filter(current => {
                if (!query || query === "") {
                  return true
                }
                return (
                  current?.name &&
                  current.name
                    .toLowerCase()
                    .includes(query.toLowerCase())
                )
              })
              .map(current => {
                return (
                  <div
                    key={current.user}
                    id="aid-monitor"
                    className={
                      selectedAidMonitorId === current.user
                        ? `${cls.driver_active} ${cls.driver}`
                        : cls.driver
                    }
                    onClick={() => {
                      handleAidMonitorData(current)
                    }}
                  >
                    <label
                      htmlFor="aid-monitor"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <Box paddingTop={"5px"}>
                        {current?.avatar ? (
                          <img
                            src={current?.avatar}
                            style={{
                              width: "30px",
                              height: "30px",
                              margin: "2px",
                              padding: "1px",
                              borderRadius: "50%"
                            }}
                          />
                        ) : (
                          <DriverProfileIcon
                            style={{
                              width: "30px",
                              height: "37px",
                              marginLeft: "3px",
                              marginRight: "3px"
                            }}
                          />
                        )}
                      </Box>
                      <NCText
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px"
                        }}
                      >
                        {current?.name}
                      </NCText>
                    </label>
                  </div>
                )
              })
          ) : (
            <Box style={{ textAlign: "center", padding: "20px" }}>
              <NCText style={{ color: "#9CA3AF" }}>No Aid/Monitors available</NCText>
            </Box>
          )}
        </Box>
      </Grid>
    </>
  )

  return (
    <NCModal
      open={modalState}
      title={selectedAidMonitor ? "Change Aid/Monitor" : "Add Aid/Monitor"}
      text={requestModal}
      onClose={() => handleClose()}
      submitButton={
        <NCButton
          variant="contained"
          color="primary"
          disableElevation
          disabled={submitting || assignAidMonitor.isLoading || !selectedAidMonitorId}
          onClick={() => handleAssignAidMonitor()}
          style={{ width: "auto", marginRight: "12px" }}
        >
          {submitting || assignAidMonitor.isLoading ? "Assigning..." : (selectedAidMonitor ? "Change Aid/Monitor" : "Add Aid/Monitor")}
        </NCButton>
      }
    />
  )
}
export default AddChangeAidMonitorModal
